import appendLocale from './appendLocale';

export const constructCompanyLink = (locale, companyId) =>
  appendLocale(locale, `/company/${companyId}`);

export const constructStaffLink = (locale, staffId) => appendLocale(locale, `/staff/${staffId}`);
